class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.freeSamples = document.querySelector('.general-samples-swiper.swiper');
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    requestAnimationFrame(() => this.applyMinMaxifyLimits());
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    if (document.readyState === "loading") {
      document.addEventListener('DOMContentLoaded', () => {
        this.initAccordion();
        window.calculatePromotions();
      });
    } else {
      this.initAccordion();
      window.calculatePromotions();
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  
  getVariantQuantityBreakdown(parsedItems) {
    const variantQuantities = {};

    parsedItems.forEach(item => {
      const variantId = item.variant_id;
      const isDiscounted = item.total_discount > 0;
      const qty = item.quantity;

      if (!variantQuantities[variantId]) {
        variantQuantities[variantId] = {
          total: 0,
          discounted: 0,
          fullPrice: 0,
          items: []
        };
      }

      variantQuantities[variantId].total += qty;
      if (isDiscounted) {
        variantQuantities[variantId].discounted += qty;
      } else {
        variantQuantities[variantId].fullPrice += qty;
      }

      variantQuantities[variantId].items.push(item);
    });

    return variantQuantities;
  }

  getMaxQuantityFromMetafields(variantId) {
    const metafieldsScript = document.querySelector(`.CartLineMetafields[data-variant-id="${variantId}"]`);
    let max = SHOP_DEFAULT_MAX;

    if (metafieldsScript) {
      try {
        const { variant = {}, product = {} } = JSON.parse(metafieldsScript.textContent);

        if (product.bundle_handles && BUNDLE_DEFAULT_MAX) {
          max = BUNDLE_DEFAULT_MAX;
        }

        if (variant.max_quantity != null) {
          max = Number(variant.max_quantity);
        } else if (product.max_quantity != null) {
          max = Number(product.max_quantity);
        }
      } catch (err) {
        console.warn('Failed to parse metafields JSON for variant', variantId, err);
      }
    }

    return max;
  }

  applyMinMaxifyLimits(runDuplicatePass = true) {
    document.querySelectorAll('.quantity-container.cart-drawer-non-bundle [data-quantity-variant-id]').forEach((selectEl)  => {
        if (selectEl.dataset.dupAdjusted === '1') return;

        const variantId = selectEl.getAttribute('data-quantity-variant-id');
        const currentQty = Number(selectEl.value);
        let max = this.getMaxQuantityFromMetafields(variantId), min = 1, step = 1;

        selectEl.innerHTML = '';
        const allowZero = true;
        if (allowZero) {
          selectEl.innerHTML += `<option value="0"${currentQty === 0 ? ' selected' : ''}>0</option>`;
        }

        for (let i = min; i <= max; i += step) {
          const selected = i === currentQty ? 'selected' : '';
          selectEl.innerHTML += `<option value="${i}" ${selected}>${i}</option>`;
        }

        selectEl.setAttribute('min', String(min));
        selectEl.setAttribute('max', String(max));
        selectEl.setAttribute('step', String(step));
      });

      if (runDuplicatePass) this.adjustQuantityLimitsForDuplicateVariants();
    }

  adjustQuantityLimitsForDuplicateVariants() {
    const updateQuantitySelectors = () => {
      const rows = Array.from(document.querySelectorAll('.cart-item'));
      const variantMap = {};

      rows.forEach(row => {
        const itemKey = row.getAttribute('data-item-key') || '';
        const variantIdFromKey = itemKey.split(':')[0] || '';
        const variantIdFromSelect = row.querySelector('select[data-quantity-variant-id]')?.dataset.quantityVariantId || '';
        const variantId = String(variantIdFromSelect || variantIdFromKey);
        const isBundle = row.querySelector('select[data-quantity-variant-id]')?.dataset.isBundle === 'true' || false ;

        const selectEl = row.querySelector('select[data-quantity-variant-id]');
        if (!selectEl) return;

        const qty = Number(selectEl.value) || 0;

        if (!variantMap[variantId]) variantMap[variantId] = [];
        variantMap[variantId].push({ row, qty, selectEl, isBundle });
      });

      const hasDuplicates = Object.values(variantMap).some(items => items.length > 1);
      if (!hasDuplicates) {
        document.querySelectorAll('select[data-quantity-variant-id][data-dup-adjusted="1"]').forEach(sel => sel.removeAttribute('data-dup-adjusted'));
        return;
      }

      Object.entries(variantMap).forEach(([variantId, items]) => {
        if (items.length < 2) return;
        const maxQty = this.getMaxQuantityFromMetafields(variantId);
        const totalQty = items.reduce((sum, item) => sum + item.qty, 0);

        items.forEach(({ qty: currentQty, selectEl, isBundle }) => {
          const otherQty = totalQty - currentQty;
          const availableQty = Math.max(maxQty - otherQty, 0);

          const optionCount = isBundle ? 1 : availableQty;

          selectEl.innerHTML = '';
          for (let i = 0; i <= optionCount; i++) {
            const selected = i === currentQty ? 'selected' : '';
            selectEl.innerHTML += `<option value="${i}" ${selected}>${i}</option>`;
          }

          selectEl.setAttribute('min', '0');
          selectEl.setAttribute('max', String(optionCount));
          selectEl.setAttribute('step', '1');

          selectEl.dataset.dupAdjusted = '1';
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateQuantitySelectors, { once: true });
    } else {
      requestAnimationFrame(updateQuantitySelectors);
    }
  }


  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

    if (inputValue < event.target.dataset.min) {
      cartItems.updateQuantity(index, 0);
      return;
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (event.target.step && inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    window.calculatePromotions();
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-bag-specials',
        section: document.getElementById('cart-bag-specials').dataset.id,
        selector: '#cart-bag-specials',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });


    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

        if (!parsedState.items || !Array.isArray(parsedState.items)) {
          return;
        }

        if (!parsedState.sections) {
          return fetch(`${window.location.pathname}?sections=${this.getSectionsToRender().map(s => s.section).join(',')}`)
            .then(res => res.json())
            .then((newSections) => {
              this.getSectionsToRender().forEach((section) => {
                const el = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                if (el && newSections[section.section]) {
                  el.innerHTML = this.getSectionInnerHTML(newSections[section.section], section.selector);
                }
              });
            });
        }

        const parsedItems = parsedState.items;
        const nonSampleItems = parsedItems.filter(item =>
          item.properties._freesample !== 'true'
        );

        if (quantity === 0 && lineItem) {
            lineItem.remove();

            if (nonSampleItems.length === 0) {

              return fetch(window.routes.cart_url + '/clear.js', {
                method: 'POST'
              })
              .then(r => r.json())
              .then(() => {
                this.classList.add('is-empty');
                document.querySelector('#Details-FreeSamples')?.classList?.add('hidden');

                const sectionsToRender = this.getSectionsToRender();

                return fetch(`${window.location.pathname}?sections=${sectionsToRender.map(s => s.section).join(',')}`)
                  .then(res => res.json())
                  .then((newSections) => {
                    
                    sectionsToRender.forEach((section) => {
                      const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                      if (elementToReplace && newSections[section.section]) {
                        elementToReplace.innerHTML = this.getSectionInnerHTML(
                          newSections[section.section],
                          section.selector
                        );
                      }
                    });
                  });
              });
             
            }
        }

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace && parsedState.item_count > 0) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }

          if(elementToReplace.id == 'cart-bag-specials') {
            this.initAccordion();
          }
        });

        this.applyMinMaxifyLimits();
        if (parsedState && Array.isArray(parsedState.items)) {
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }

          if (this.freeSamples) {
            window.initFreeSamplesSwiper(document.querySelector('.general-samples-swiper.swiper'));
          }
          this.updateLiveRegions(line, message);
        }
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  accordionClickHandler = (e) => {
    const el = e.target;
    const header = el.classList.contains('accordion-header') ? el : el.closest('.accordion-header');
    const isExpanded = header.getAttribute('aria-expanded') === 'true';
    const content = document.getElementById(header.getAttribute('aria-controls'));

    header.setAttribute('aria-expanded', !isExpanded);
    content.classList.toggle('expanded');
  }

  accordionKeyboardHandler = (e) => {
    const el = e.target;
    const header = el.classList.contains('accordion-header') ? el : el.closest('.accordion-header');
    if (e.key === 'Enter' || e.key === ' ') {
        header.click();
    }
  }

  initAccordion() {
    const headers = document.querySelectorAll('.accordion-header');

    headers.forEach(header => {
      header.removeEventListener('click', this.accordionClickHandler);
      header.removeEventListener('keydown', this.accordionKeyboardHandler);

      header.addEventListener('click', this.accordionClickHandler);
      header.addEventListener('keydown', this.accordionKeyboardHandler);
    });

    this.initRecommendationCarousels();

    const nonSwiperContainers = document.querySelectorAll('.recommended-product-form__input-non-carousel');
    nonSwiperContainers.forEach(container => {
      this.initBagSpecialsSwatchListeners();
    });
  }

  initRecommendationCarousels() {
    const recSwiperContainers = document.querySelectorAll('#mini-cart-recommendations .recommended-swiper-container');
    recSwiperContainers.forEach((container, index) => {
      const swiperEl = container.querySelector('.swiper');
      if (swiperEl && !swiperEl.swiper) {
        const prevButton = container.querySelector('.recommended__swiper-button-prev');
        const nextButton = container.querySelector('.recommended__swiper-button-next');
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 3,
          loop: true,
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
          },
          preventClicks: true,
          preventClicksPropagation: false,
        });

        this.initBagSpecialsSwatchListeners();

      } else {
        console.warn('No element with class .swatch-carousel found.');
      }
    });
  }

  initBagSpecialsSwatchListeners() {
    document.querySelectorAll('.recommended-product .bag-special-swatch-input').forEach((swatch) => {
      // Skip if listener already attached
      if (swatch.dataset.bagSpecialClickListenerAttached === 'true') return;

      swatch.addEventListener('click', (event) => {
        const swatchVariantId = swatch.dataset.variantId;
        const productEl = swatch.closest('.recommended-product');
        const productHandle = productEl.getAttribute('data-product-handle');

        this.updateBagSpecialVariantImage(productHandle, swatchVariantId, productEl);
      });

      // Mark as having listener attached
      swatch.dataset.bagSpecialClickListenerAttached = 'true';
    });
  }

  updateBagSpecialVariantImage(productHandle, variantId, container) {
    fetch(`/products/${productHandle}`)
      .then(response => response.text())
      .then(productHtml => {
        const variantHtml = new DOMParser().parseFromString(productHtml, 'text/html');
        const scriptTag = variantHtml.querySelector('script.product-json-data');
        if (!scriptTag) {
          console.warn('Product JSON script tag not found');
          return;
        }

        try {
          const productJson = JSON.parse(scriptTag.textContent);
          const variant = productJson.variants.find(v => String(v.id) === String(variantId));
          if (!variant) {
            console.warn(`Variant ID ${variantId} not found in product ${productHandle}`);
            return;
          }

          const imageUrl = variant.featured_image?.src || (productJson.images.length ? productJson.images[0] : null);
          if (!imageUrl) {
            console.warn('No image found for variant or product');
            return;
          }

          const mainImage = container.querySelector('.cart-item__image');
          if (mainImage) {
            mainImage.src = imageUrl;
          }
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      })
      .catch(error => {
        console.error('Error fetching product HTML:', error);
      });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
